import FloatingTextFiled from "../../../sharedPages/CommonComponents/FloatingTextFiled/FloatingTextFiled";
import { toastify } from "../../../../helpers/toast/toastify";

const CombineInput = ({ 
  subscription, 
  updateSubscription, 
  formErrors, 
  className = "", 
  focusedAllowed = true 
}) => {
  const MAX_VALUE = 99999;
  const MIN_VALUE = 1;

  const handleMonthlyChange = (e) => {
    let value = e.target.value.replace(/[^0-9.]/g, "");
    value = value.replace(/(\..*)\./g, "$1");
    
    // Check if value exceeds maximum
    if (value && +value > MAX_VALUE) {
      toastify(`Please enter a value between ${MIN_VALUE}-${MAX_VALUE} for monthly price`);
      return;
    }
    
    updateSubscription("monthlyfee", value);
  };

  const handleYearlyChange = (e) => {
    let value = e.target.value.replace(/[^0-9.]/g, "");
    value = value.replace(/(\..*)\./g, "$1");
    
    // Check if value exceeds maximum
    if (value && +value > MAX_VALUE) {
      toastify(`Please enter a value between ${MIN_VALUE}-${MAX_VALUE} for yearly price`);
      return;
    }
    
    updateSubscription("yearlyfee", value);
  };

  return (
    <>
      <div
        className={`combimeInputBox ${
          (formErrors.monthlyfee || formErrors.yearlyfee) && "invalid"
        } ${
          subscription.monthlyfee && subscription.monthlyfee !== "$" && focusedAllowed ? "always_focused" : ""
        } ${className}`}
      >
        <div className="inputBox">
          <FloatingTextFiled
            className={formErrors.monthlyfee ? "invalid" : ""}
            label="Monthly"
            onChange={handleMonthlyChange}
            placeholder="Monthly"
            value={`$${subscription.monthlyfee}`}
          />
        </div>
        <div className="divider"></div>
        <div className="inputBox">
          <FloatingTextFiled
            className={formErrors.yearlyfee ? "invalid" : ""}
            label="Yearly"
            onChange={handleYearlyChange}
            placeholder="Yearly"
            value={`$${subscription.yearlyfee}`}
          />
        </div>
      </div>
    </>
  );
};

export default CombineInput;